import { FlexRow } from '@/components/common/Flex';
import Icon from '@/components/common/icons/Icon';
import { FlexProps, Grid } from '@chakra-ui/react';
import { ExternalFinancialEntityType } from '@common/financialEntities';
import { getManualAddAccountTypeItems } from '@common/react/accounts';
import { useState } from 'react';
import { FlexCol } from '../common/Flex';
import InputField from '../common/InputField';
import BasicModalLayout from '../common/modals/BasicModalLayout';
import { groupHoverStyleProps, hoverStyleProps } from '../common/styleHelpers';
import { Text } from '../common/Typography';

export interface ManualAddTypeViewProps extends FlexProps {
    title: string;
    types: ExternalFinancialEntityType[];
    onSelectType: (type: ExternalFinancialEntityType) => void;
}

const ManualAddTypeView = ({
    title,
    types,
    onSelectType,
    ...props
}: ManualAddTypeViewProps) => {
    const [search, setSearch] = useState('');

    const items = getManualAddAccountTypeItems(types)
        // Filter by search
        .filter((item) =>
            item.title.toLowerCase().includes(search.toLowerCase())
        );

    return (
        <BasicModalLayout
            title={title}
            headerProps={{ mb: 4 }}
            subtitle={'Choose what type to add'}
            contentProps={{ grow: 0 }}
            content={
                <FlexCol w="full">
                    <InputField
                        name="type-search"
                        type="text"
                        inputProps={{
                            size: 'sm',
                            variant: 'outline',
                            h: 8,
                            mb: 4,
                        }}
                        placeholder="Start typing to filter..."
                        value={search}
                        onChange={setSearch}
                    />

                    <Grid
                        templateColumns="repeat(2, 1fr)"
                        gap={4}
                        mb={8}
                        w="full"
                    >
                        {items.map((item) => {
                            return (
                                <FlexRow
                                    key={item.type}
                                    px={3}
                                    py={3}
                                    gap={2}
                                    align="center"
                                    borderColor="border"
                                    borderWidth={2}
                                    rounded="md"
                                    {...hoverStyleProps({
                                        borderColor: 'blue.500',
                                    })}
                                    onClick={() => onSelectType(item.type)}
                                    role="group"
                                >
                                    <Icon
                                        name={item.iconName}
                                        size="md"
                                        color="text"
                                        {...groupHoverStyleProps({
                                            color: 'blue.500',
                                        })}
                                    />
                                    <Text
                                        fontWeight="semibold"
                                        fontSize="sm"
                                        textAlign="center"
                                        {...groupHoverStyleProps({
                                            color: 'blue.500',
                                        })}
                                    >
                                        {item.title}
                                    </Text>
                                </FlexRow>
                            );
                        })}
                    </Grid>
                </FlexCol>
            }
            {...props}
        />
    );
};

export default ManualAddTypeView;
